import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import FluidContainer from "../FluidContainer";
import { useScrollToTop } from "../../hooks";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  wrapper: {
    [breakpoints.down("sm")]: {
      marginTop: typography.pxToRem(150)
    },
    margin: "auto",
    marginTop: typography.pxToRem(120),
    paddingTop: typography.pxToRem(20),
    paddingBottom: typography.pxToRem(15),
    borderRadius: 2.5,
    minHeight: typography.pxToRem(382),
    backgroundColor: palette.background.dialogSecondary
  },
  fullScreenWrapper: {
    marginTop: 0,
    paddingTop: 0,
    zIndex: 1,
    paddingBottom: 0,
    [breakpoints.down("sm")]: {
      marginBottom: 0
    }
  }
}));
export default (({
  component: Component,
  fullScreenStep,
  wrapperClassName,
  ...props
}) => {
  const styles = useStyles();
  useScrollToTop();

  if (fullScreenStep) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      justify: "flex-start",
      alignItems: "center",
      className: clsx(styles.wrapper, styles.fullScreenWrapper, wrapperClassName)
    }, /*#__PURE__*/React.createElement(Component, props));
  }

  return /*#__PURE__*/React.createElement(FluidContainer, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "flex-start",
    alignItems: "center",
    className: clsx(styles.wrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement(Component, props)));
});